import {
  deepPurple500, deepPurple700,
  redA200,
  grey100, grey200, grey300, grey400, grey500,
  white, darkBlack, fullBlack,
} from 'material-ui/styles/colors';
import { fade } from 'material-ui/utils/colorManipulator';
import getMuiTheme from 'material-ui/styles/getMuiTheme';

// Theming Configuration
export const theme = {
  primary1Color: deepPurple500,
  primary2Color: deepPurple700,
  primary3Color: grey400,
  accent1Color: redA200,
  accent2Color: grey100,
  accent3Color: grey500,
  textColor: darkBlack,
  alternateTextColor: white,
  canvasColor: white,
  borderColor: grey300,
  disabledColor: fade(darkBlack, 0.3),
  pickerHeaderColor: deepPurple500,
  clockCircleColor: fade(darkBlack, 0.07),
  shadowColor: fullBlack,
  headerColor: grey200,
  backgroundColor: grey300,
};

export const muiTheme = getMuiTheme({
  palette: theme,
});



// WEBPACK FOOTER //
// ./src/utils/getTheme.js